import { render, staticRenderFns } from "./PatientOverview.vue?vue&type=template&id=5109b54a&scoped=true&"
import script from "./PatientOverview.vue?vue&type=script&lang=js&"
export * from "./PatientOverview.vue?vue&type=script&lang=js&"
import style0 from "./PatientOverview.vue?vue&type=style&index=0&id=5109b54a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5109b54a",
  null
  
)

export default component.exports